class WLSUGC extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      playingClass: 'playing',
      splideClass: 'splide',
      splideSlideClass: 'splide__slide',
      video: 'js-wls-ugc-video',
      slide: 'splide__slide',
    };

    this.elements = {
      videos: this.querySelectorAll(`.${this.classes.video}`),
      slides: this.querySelectorAll(`.${this.classes.slide}`)
    };

    console.log(this.elements.slider)

    document.addEventListener("DOMContentLoaded", this.initialize.bind(this));
  }

  initialize() {
    if (this) {
      this.initSlider(this);
    }
    this.checkVideos();
  }

  checkVideos() {
    if (this.elements.videos.length > 0) {
      this.elements.videos.forEach((video) => {
        const parentItem = video.closest(".wls-ugc__item");
        video.addEventListener("click", () =>
          this.toggleVideo(video, parentItem),
        );
      });
    } else {
      requestAnimationFrame(this.checkVideos.bind(this));
    }
  }

  toggleVideo(video, parentItem) {
    this.stopPlayingCurrentVideo(video.id);
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
    if (parentItem) {
      parentItem.classList.toggle(this.classes.playingClass, !video.paused);
    }
  }

  stopPlayingCurrentVideo(videoId) {
    const currentPlayingParent = document.querySelector(
      ".wls-ugc__item.playing",
    );
    if (currentPlayingParent) {
      currentPlayingParent.classList.remove(this.classes.playingClass);
      const currentPlayingVideo = currentPlayingParent.querySelector("video");
      if (currentPlayingVideo?.id !== videoId) {
        currentPlayingVideo.pause();
      }
    }
  }

  initSlider(ugcSlider) {
    const slideCount = this.elements.slides.length;
    const isMobile = window.innerWidth <= 1024; // Check if it's a mobile device (1024px or less)

    // If there are 4 or fewer slides on desktop, show static content
    if (slideCount <= 4 && !isMobile) {
      if (ugcSlider.splide) {
        ugcSlider.splide.destroy(); // Destroy the slider if already initialized
      }

      ugcSlider.classList.remove(this.classes.splideClass);
      if (this.elements.slides.length > 0) {
        this.elements.slides.forEach((slide) => {
          slide.classList.remove(this.classes.splideSlideClass);
          slide.style.display = "inline-block";
          slide.style.width = "calc(25% - 1.6rem)"; // Set card width for 4 slides on desktop
          slide.style.marginRight = "1.6rem";
        });
      }


      console.log("Static content displayed on desktop.");
    } else if (slideCount > 4 || isMobile) {
      // If more than 4 slides or on mobile, initialize the slider
      const ugcVideoSlider = new Splide(ugcSlider, {

        perPage: isMobile ? 1 : 4, // 1 slide per view on mobile, 4 on desktop
        //perMove: isMobile ? 1 : 4,
        type: "loop",
        focus: "left",
        pagination: true,
        arrows: true, // Show arrows on all devices
        gap: "1.6rem",
        drag: true,
        snap: isMobile, // Snap only on mobile
        breakpoints: {
          650: {
            perPage: 'auto',
            padding: { left: "0", right: "0" },
          },
          767: {
            perPage: 2,
          },
        },
      });

      if (ugcSlider.splide) {
        ugcSlider.splide.destroy(); // Destroy the slider if already initialized
      }

      ugcSlider.splide = ugcVideoSlider; // Save slider instance
      ugcVideoSlider.mount(); // Initialize the slider
      console.log("Slider initialized.");
    }
  }
}

const customElementName = "wls-ugc";
if (!customElements.get(customElementName)) {
  window.customElements.define(customElementName, WLSUGC);
}
